module.exports = __webpack_public_path__ + "img/branches.c6690d9a.svg";